import { Injectable } from "@angular/core";
import {
  ButtonColor,
  CloseMfaData,
  SimpleDialogComponent,
  SimpleDialogData,
  HiddenPhonePipe,
  MessageService,
  MfaActionsService,
  MfaErrorCodeType,
  MfaService,
  VerifyMfaCodeData,
  CommonActionKey,
  isAuthThrottleError,
} from "common";
import {
  SingInErrorResponse,
  SingInResponse,
} from "../../user/user-sign-in/models/sign-in.models";
import { MatDialog } from "@angular/material/dialog";
import { CustomerFacade } from "common";
import { ConfirmNewPhoneNumberRequest } from "common";

@Injectable()
export class MfaChangePhoneNumberService {
  constructor(
    private mfaActions: MfaActionsService,
    private customerFacade: CustomerFacade,
    private mfaService: MfaService,
    private messageService: MessageService,
    private hiddenPhonePipe: HiddenPhonePipe,
    private dialog: MatDialog
  ) {}

  verify(data: VerifyMfaCodeData): void {
    const request: ConfirmNewPhoneNumberRequest = {
      customerId: data.mfaData.contextData.customerId,
      oldPhoneNumber: data.mfaData.contextData.oldPhoneNumber,
      mfaToken: data.mfaData.mfaToken,
      mfaCode: data.mfaCode,
    };

    this.customerFacade
      .confirmMobilePhoneNumberChange(request)
      .subscribe((data: SingInResponse & SingInErrorResponse) => {
        this.handleMfaLoginResponse(data);
      });
  }

  close(data: CloseMfaData): void {
    const dialogData: SimpleDialogData = {
      title: "Phone number not verified",
      body: `If you choose not to verify your new phone number at this time,
      we will continue to use your old phone number
      ${this.hiddenPhonePipe.transform(data.contextData.oldPhoneNumber)} to
      verify your account. To verify your new phone number press CONTINUE below.`,
      actions: [
        {
          label: "GO TO DASHBOARD",
          buttonColor: ButtonColor.Default,
          actionKey: CommonActionKey.GoToDashboard,
        },
        { label: "CONTINUE", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Continue },
      ],
    };
    SimpleDialogComponent.show(this.dialog, dialogData).subscribe((actionKey: string) => {
      if (actionKey === CommonActionKey.GoToDashboard) {
        this.mfaService.clearMfaData();
        this.customerFacade.redirectToDashboard();
      }
    });
  }

  private handleMfaLoginResponse(data: SingInResponse & SingInErrorResponse) {
    if (!data?.hasError) {
      this.customerFacade.redirectToDashboard();
      this.messageService.success(
        "Your new number has been successfully verified. We will use it to verify your account"
      );
      this.mfaService.handleMfaSuccess();
      return;
    }

    if (data?.errorCode === MfaErrorCodeType.InvalidMfaCode) {
      this.mfaActions.invalidCode();
      return;
    }

    if (isAuthThrottleError(data?.errorCode)) {
      return;
    }

    this.mfaService.handleMfaError();
  }
}
